export class ArticleConnectionPropertyValue {
  public static readonly Wire_CONNECTION_TYPE: string = 'Leitereinführung';
  public static readonly CODING_FINGER_CONNECTION_TYPE: string = 'Kodiernase';
  public static readonly CONTACT_CONNECTION_TYPE: string = 'Kontakt';
  public static readonly N_BUSBAR_CONNECTION_TYPE: string = 'N-Busbar';
  public static readonly BRIDGE_SHAFT_CONNECTION_TYPE: string = 'Brückerschacht';
  public static readonly BRIDGE_SLOT_CONNECTION_TYPE: string = 'Brückerschlitz';
  public static readonly XCOM_TYPE: string = 'X-Com-Eingang';
  public static readonly MOUNTING_RAIL_15_TYPE: string = 'TS15';
  public static readonly MOUNTING_RAIL_35_TYPE: string = 'TS35';
  public static readonly MOUNTING_RAIL_99_TYPE: string = 'TS99';
}
